import type { UnifiedPdpStoneType } from '@/views/product/engagement-ring/mock/stoneRecommendationsMock.ts'

type UnifiedPdpFilterTooltipAttribute = 'carat' | 'colour' | 'clarity'

const getStoneSearchBasePath = (stoneType: UnifiedPdpStoneType): string => {
    switch (stoneType) {
        case 'lab-grown-diamonds':
            return '/diamond-search/lab-grown-diamonds'
        case 'natural-diamonds':
            return '/diamond-search/natural-diamonds'
        case 'gemstones':
            return '/diamond-search/gemstones'
    }
}

export const getUnifiedPdpFilterTooltipPath = (
    stoneType: UnifiedPdpStoneType,
    attribute: UnifiedPdpFilterTooltipAttribute
): string => {
    const basePath = getStoneSearchBasePath(stoneType)

    switch (attribute) {
        case 'carat':
            return `${basePath}/carat-weight`
        case 'colour':
            return stoneType === 'gemstones'
                ? `${basePath}/colour-grade`
                : `${basePath}/colour`
        case 'clarity':
            return `${basePath}/clarity`
    }
}

export const getUnifiedPdpStoneTypeTooltipPath = (
    stoneType: UnifiedPdpStoneType
): string => {
    switch (stoneType) {
        case 'lab-grown-diamonds':
            return '/diamond-search/tabs/lab-grown-diamonds'
        case 'natural-diamonds':
            return '/diamond-search/tabs/natural-diamonds'
        case 'gemstones':
            return '/diamond-search/tabs/gemstones'
    }
}
